import { IQueryHookOptions, IEntitlement, IError } from '@comptia-sso/core';
import { useQuery, QueryObserverResult } from 'react-query';

// Config.
import { env } from 'config';

// Services.
import { getProfileEntitlements } from 'services';

type UseProfileEntitlements = [
  IEntitlement[],
  IQueryHookOptions & {
    refetch: () => Promise<QueryObserverResult<IEntitlement[], IError>>;
  },
];

export const useProfileEntitlements = (id = ''): UseProfileEntitlements => {
  const {
    data = [],
    error,
    isError,
    isLoading,
    refetch,
  } = useQuery<IEntitlement[], IError>(
    ['profile', 'entitlements'],
    () => getProfileEntitlements(id),
    {
      enabled: env.FLAG_LEARNING_SYSTEMS_ENABLED && !!id,
    },
  );

  return [data, { error, isError, isLoading, refetch }];
};
